import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/Components/Header/Header.component';
import { FooterComponent } from './shared/Components/Footer/Footer.component';
import { FazerCotacaoComponent } from './Components/fazer-cotacao/fazer-cotacao.component';
import { ConfirmacaoComponent } from './Components/confirmacao-cotacao/confirmacao.component';
import { MostrarProdutosComponent } from './Components/mostrar-produtos/mostrar-produtos.component';
import { PagamentoComponent } from './Components/pagamento/pagamento.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { Page404Component } from './shared/Page404/page404.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import { RouterModule  } from '@angular/router';
import { ModalAdicionaisComponent } from './Components/modal-adicionais/modal-adicionais.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { LoaderComponent } from './shared/Components/loader/loader.component';
import { LoaderService } from './shared/Services/loader/loader.service';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { LoaderInterceptor } from './shared/loader.interceptor';
import { ModalMensajeComponent } from '../app/Components/modal-mensaje/modal-mensaje.component';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
//export const options: Partial<IConfig> | (() => Partial<IConfig>);


@NgModule({
  declarations: [
    AppComponent
    , HeaderComponent
    , FooterComponent
    , FazerCotacaoComponent
    , Page404Component
    , AppComponent
    , MostrarProdutosComponent
    , ModalAdicionaisComponent
    , AppComponent
    , PagamentoComponent
    , ConfirmacaoComponent
    , LoaderComponent
    , ModalMensajeComponent
  ],
  imports: [
    BrowserModule
    , AppRoutingModule
    , HttpClientModule
    , ReactiveFormsModule
    , BrowserAnimationsModule
    , NgbModule
    , FormsModule
    , RouterModule
    , NgxMaskModule.forRoot(options)
  ],
  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }],
  bootstrap: [ AppComponent ],
  entryComponents:[ ModalAdicionaisComponent,ModalMensajeComponent ]
}) export class AppModule {
  constructor(public http: HttpClient) {
    this.http.get('localhost/api/googleapiphp/powertag.php?q=car&count=3')
      .subscribe((r) => {
        console.log(r);
      });
  }
 
}


  